import { SUBSCRIPTION_PAYMENT_FORM_PATH } from 'Pods/SubscriptionCheckout/Constants/paths'

export const TODO_LEARN_MORE_HREF = '#'
export const STUDIO_RETURN_URL = '/ai'
export const RETURN_URL_QUERY = `return_url=${encodeURIComponent(STUDIO_RETURN_URL)}`

export function buildSubscriptionHref(subscriptionPaymentFormUrl, returnUrl = STUDIO_RETURN_URL) {
  return `${subscriptionPaymentFormUrl || SUBSCRIPTION_PAYMENT_FORM_PATH}?return_url=${encodeURIComponent(returnUrl)}`
}
